document.addEventListener("DOMContentLoaded", (event) => {
  document.addEventListener("product:quantity-update", function (evt) {
    const prodQuantity = evt.detail.quantity;
    const prodPrice = evt.detail.variant.price;
    const prodPriceSubTotal = `$${(prodQuantity * (prodPrice/100)).toFixed(2)}`;
    const atcPrice = document.querySelector('.product-form__controls-group--submit [data-price]');
    const stickyAtcPrice = document.querySelector('.sticky-atc-bar__price [data-price]');
    if (atcPrice && stickyAtcPrice) {
       atcPrice.textContent = prodPriceSubTotal;
       stickyAtcPrice.textContent = prodPriceSubTotal;
    }
  })
  document.addEventListener("product:variant-change", function (evt) {
    let prodQuantity = document.querySelector('.quantity-input__input').value;
    console.log(typeof prodQuantity)
    if (Number(prodQuantity) === 0) {
      prodQuantity = 1;
    }
    const prodPrice = evt.detail.variant.price;
    const prodPriceSubTotal = `$${(prodQuantity * (prodPrice/100)).toFixed(2)}`;
    const atcPrice = document.querySelector('.product-form__controls-group--submit [data-price]');
    if (!!atcPrice === false) {
      // const priceEl = document.createElement('SPAN');
      // priceEl.textContent = prodPriceSubTotal;
      // priceEl.setAttribute('data-price', "");
      // const atcText = document.querySelector('.product-form__controls-group--submit [data-add-to-cart-text]');
      // atcText.append(priceEl);
    }
    const stickyAtcPrice = document.querySelector('.sticky-atc-bar__price [data-price]');
    if (stickyAtcPrice) {
       stickyAtcPrice.textContent = prodPriceSubTotal;
    }
  })
});

